import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paging-search',
  templateUrl: './paging-search.component.html',
  styleUrls: ['./paging-search.component.scss']
})
export class PagingSearchComponent implements OnInit {
  constructor() {}
  @Input() label = '';
  @Output() value = new EventEmitter<any>();

  ngOnInit(): void {}

  valueFormat(value: string): any {
    this.value.emit(value);
  }
}
